import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {IPhone} from '../../shared/model/interface/phone.model.interface';
import {map} from "rxjs/operators";
import {PhoneStatusList} from "../../shared/model/interface/phone-status.model.interface";
import {IEditPhone} from "../../shared/model/interface/edit-phone.model.interface";
import {INewPhone} from "../../shared/model/interface/new-phone.model.interface";

@Injectable({
  providedIn: 'root'
})
export class CustomerPhoneService {
  private static readonly _URL = environment.backendUrl + '/customers';

  constructor(private httpClient: HttpClient) {
  }

  create(customerId: number, phone: INewPhone) {
    return this.httpClient.post<IPhone>(CustomerPhoneService._URL + `/${customerId}/phones/create`, phone);
  }

  delete(phoneId: number) {
    return this.httpClient.delete(CustomerPhoneService._URL + `/phones/${phoneId}/delete`);
  }

  edit(phoneId: number, phone: IEditPhone) {
    return this.httpClient.put(CustomerPhoneService._URL + `/phones/${phoneId}/edit`, phone);
  }

  verify(phones: string[]) {
    return this.httpClient.post(CustomerPhoneService._URL + `/phones/verify`, phones);
  }

  getStatuses() {
    return this.httpClient.get<PhoneStatusList>(CustomerPhoneService._URL + `/phones/statuses`).pipe(
      map(data => new PhoneStatusList(data))
    )
  }
}
